export const CURRENCIES = {
  USD: { symbol: "$", rate: 1 },
  EUR: { symbol: "€", rate: 0.92 },
  GBP: { symbol: "£", rate: 0.79 },
};

export const formatMoney = (usd, currency = "USD") => {
  const c = CURRENCIES[currency] || CURRENCIES.USD;
  return `${c.symbol}${Math.round(usd * c.rate).toLocaleString("en-US")}`;
};

export const TREATMENTS = [
  {
    id: "knee-replacement",
    name: "Knee Replacement",
    category: "Orthopedics",
    us: 35000,
    eu: 28000,
    india: 6000,
    stay: "10–12 day stay",
    highlights: ["Stryker & Zimmer Biomet implants", "Robotic-assisted surgery", "Private rehab suite"],
    image: "https://images.pexels.com/photos/32260065/pexels-photo-32260065.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "hip-replacement",
    name: "Hip Replacement",
    category: "Orthopedics",
    us: 40000,
    eu: 30000,
    india: 6500,
    stay: "12–14 day stay",
    highlights: ["Minimally invasive anterior approach", "Ceramic-on-ceramic joint", "Physiotherapy included"],
    image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=940&auto=format&fit=crop",
  },
  {
    id: "cardiac-procedures",
    name: "Cardiac Procedures",
    category: "Cardiology · CABG / Valve",
    us: 75000,
    eu: 50000,
    india: 7500,
    stay: "14–16 day stay",
    highlights: ["Beating-heart bypass surgery", "JCI-accredited cardiac centres", "Dedicated cardiac ICU"],
    image: "https://images.pexels.com/photos/31499386/pexels-photo-31499386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "bariatric-surgery",
    name: "Bariatric Surgery",
    category: "Metabolic",
    us: 25000,
    eu: 20000,
    india: 5000,
    stay: "7–9 day stay",
    highlights: ["Laparoscopic sleeve gastrectomy", "Full dietitian & post-op plan", "Luxury wellness recovery"],
    image: "https://images.unsplash.com/photo-1535272126276-63decfb8c4d7?q=80&w=940&auto=format&fit=crop",
  },
  {
    id: "ivf-treatment",
    name: "IVF & Fertility",
    category: "Reproductive Health",
    us: 18000,
    eu: 14000,
    india: 3500,
    stay: "18–21 day stay",
    highlights: ["ICSI & blastocyst culture", "High success rates under 35", "Confidential concierge support"],
    image: "https://images.pexels.com/photos/32115905/pexels-photo-32115905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "dental-implants",
    name: "Full-Mouth Dental Implants",
    category: "Dentistry",
    us: 12000,
    eu: 9500,
    india: 1200,
    stay: "5–7 day stay",
    highlights: ["All-on-4 / All-on-6 zirconia", "3D digital guided placement", "Lifetime implant warranty"],
    image: "https://images.unsplash.com/photo-1712215544003-af10130f8eb3?q=80&w=940&auto=format&fit=crop",
  },
  {
    id: "cataract-surgery",
    name: "Laser Cataract Surgery",
    category: "Ophthalmology · Both Eyes",
    us: 8500,
    eu: 6500,
    india: 1500,
    stay: "4–5 day stay",
    highlights: ["Premium multifocal IOL lenses", "Femtosecond laser precision", "Same-day recovery"],
    image: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?q=80&w=940&auto=format&fit=crop",
  },
  {
    id: "spine-surgery",
    name: "Spine Surgery",
    category: "Orthopedics · Fusion / Discectomy",
    us: 50000,
    eu: 38000,
    india: 7000,
    stay: "10–14 day stay",
    highlights: ["Endoscopic & minimally invasive", "Neuromonitoring precision", "Post-op rehabilitation"],
    image: "https://images.pexels.com/photos/28755708/pexels-photo-28755708.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "cosmetic-surgery",
    name: "Cosmetic Surgery",
    category: "Aesthetics · Rhinoplasty / Facelift",
    us: 22000,
    eu: 17000,
    india: 3800,
    stay: "7–10 day stay",
    highlights: ["Board-certified aesthetic surgeons", "Discreet luxury spa recovery", "Custom 3D morphing preview"],
    image: "https://images.pexels.com/photos/6875526/pexels-photo-6875526.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const savingsPct = (t) => Math.round((1 - t.india / t.us) * 100);
